import React, { useState, useRef } from 'react';
import ColorPickerModal from './ColorPickerModal';
import { isGradientConfig, getDisplayColor } from '../../utils/gradientUtils';

const ColorPicker = ({
  value,
  onChange,
  showTransparent = false,
  showGradient = true,
  label,
  size = 'default', // 'default' | 'large'
  onOpen,
  onClose,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [anchorPosition, setAnchorPosition] = useState(null);
  const buttonRef = useRef(null);

  const handleOpen = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setAnchorPosition({ top: rect.top, left: rect.right + 8 });
    }
    setIsModalOpen(true);
    onOpen?.();
  };

  const handleClose = () => {
    setIsModalOpen(false);
    onClose?.();
  };

  const isLarge = size === 'large';
  const btnSize = isLarge ? 54 : 36;
  const labelFontSize = isLarge ? '15px' : '13px';

  const isGradient = isGradientConfig(value);
  const isTransparent = value === 'transparent';
  const displayBg = isTransparent ? '#ffffff' : getDisplayColor(value);

  // 표시할 텍스트
  const displayText = isGradient
    ? 'Gradient'
    : isTransparent
      ? 'transparent'
      : (typeof value === 'string' ? value : '');

  return (
    <div>
      {label && (
        <label style={{
          display: 'block',
          fontSize: labelFontSize,
          fontWeight: '500',
          color: '#374151',
          marginBottom: '8px',
        }}>
          {label}
        </label>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {/* Color preview button */}
        <button
          ref={buttonRef}
          onClick={handleOpen}
          style={{
            width: `${btnSize}px`,
            height: `${btnSize}px`,
            borderRadius: '6px',
            border: '2px solid #e5e7eb',
            cursor: 'pointer',
            padding: 0,
            position: 'relative',
            overflow: 'hidden',
            background: isTransparent ? '#ffffff' : (isGradient ? displayBg : 'none'),
            backgroundColor: (!isGradient && !isTransparent) ? value : undefined,
            flexShrink: 0,
          }}
        >
          {isTransparent && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '-5px',
              width: '50px',
              height: '2px',
              backgroundColor: '#ef4444',
              transform: 'rotate(-45deg)',
            }} />
          )}
        </button>
        <span style={{
          fontSize: isLarge ? '14px' : '12px',
          color: '#6b7280',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
          {displayText}
        </span>
      </div>

      {isModalOpen && (
        <ColorPickerModal
          value={value}
          onChange={onChange}
          onClose={handleClose}
          showTransparent={showTransparent}
          showGradient={showGradient}
          anchorPosition={anchorPosition}
        />
      )}
    </div>
  );
};

export default ColorPicker;
